module.exports = __webpack_public_path__ + "img/sohn_lg.c20eff72.png";